import { render } from "./AHS_VDH_Patient_Profile.vue?vue&type=template&id=c24db898"
import script from "./AHS_VDH_Patient_Profile.vue?vue&type=script&lang=js"
export * from "./AHS_VDH_Patient_Profile.vue?vue&type=script&lang=js"

import "./AHS_VDH_Patient_Profile.vue?vue&type=style&index=0&id=c24db898&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__